import React from "react";
import { WifiOff } from "lucide-react";
import { useM } from "@/marketing/useM";
import { Reveal, Eyebrow } from "@/marketing/ui";
import { CtaBanner } from "@/marketing/home/Pricing";

const Step = ({ n, m }) => (
  <Reveal className="group grid grid-cols-[auto_1fr] gap-6 border-t border-white/10 py-10 transition-colors hover:border-mk-yellow md:gap-12 md:py-14">
    <span className="font-heading text-6xl font-black leading-none text-white/10 transition-colors duration-500 group-hover:text-mk-yellow md:text-8xl" data-testid={`how-step-${n}`}>0{n}</span>
    <div className="md:pt-3">
      <h3 className="font-heading text-2xl font-bold uppercase text-white md:text-4xl">{m(`how.${n}.t`)}</h3>
      <p className="mt-3 max-w-xl text-sm leading-relaxed text-mk-muted md:text-lg">{m(`how.${n}.d`)}</p>
    </div>
  </Reveal>
);

export default function HowItWorks() {
  const m = useM();
  return (
    <div data-testid="how-page">
      <section className="mx-auto grid max-w-7xl gap-12 px-6 pb-24 pt-40 lg:grid-cols-[1fr_1.5fr] lg:gap-20 lg:px-10 lg:pt-48">
        <div className="lg:sticky lg:top-32 lg:self-start">
          <Reveal>
            <Eyebrow>{m("how.eyebrow")}</Eyebrow>
            <h1 className="mt-6 font-heading text-5xl font-black leading-[0.9] text-white sm:text-6xl" data-testid="how-title">{m("how.title")}</h1>
            <p className="mt-6 text-base text-mk-muted md:text-lg">{m("how.sub")}</p>
          </Reveal>
          <Reveal delay={0.15} className="mt-10 rounded-2xl border border-mk-yellow/30 bg-mk-yellow/[0.05] p-6" >
            <div data-testid="how-offline-note">
              <WifiOff size={20} className="text-mk-yellow" />
              <p className="mt-4 font-heading text-xl font-bold uppercase text-white">{m("how.offlineT")}</p>
              <p className="mt-2 text-sm leading-relaxed text-mk-muted">{m("how.offlineD")}</p>
            </div>
          </Reveal>
        </div>
        <div>{[1, 2, 3, 4, 5, 6].map((n) => <Step key={n} n={n} m={m} />)}</div>
      </section>
      <CtaBanner />
    </div>
  );
}
